import { Link, useLocation, useNavigate } from "react-router-dom";
import { Sparkles, Package, ShieldCheck, Home } from "lucide-react";

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNav = (id: string) => {
    if (location.pathname !== "/") {
      navigate(`/?scroll=${id}`);
    } else {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <nav aria-label="Mobile Navigation" className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#FAF8F5]/95 backdrop-blur-md border-t border-border/60 flex items-center justify-around px-2 py-2 pb-safe shadow-none">
      <Link to="/" aria-label="Go to Home" className="flex flex-col items-center gap-1 text-foreground hover:opacity-70 transition-opacity min-w-[48px] min-h-[48px] justify-center px-3">
        <Home size={18} strokeWidth={1.5} />
        <span className="text-[8px] font-body font-light uppercase tracking-[0.15em]">Home</span>
      </Link>
      
      <button 
        onClick={() => handleNav('products-list')}
        aria-label="View Premium Products"
        className="flex flex-col items-center gap-1 text-foreground hover:opacity-70 transition-opacity min-w-[48px] min-h-[48px] justify-center px-3"
      >
        <Sparkles size={18} strokeWidth={1.5} />
        <span className="text-[8px] font-body font-light uppercase tracking-[0.15em]">Collection</span>
      </button>
      
      <Link 
        to="/about"
        aria-label="Our Story"
        className="flex flex-col items-center gap-1 text-foreground hover:opacity-70 transition-opacity min-w-[48px] min-h-[48px] justify-center px-3"
      >
        <Package size={18} strokeWidth={1.5} />
        <span className="text-[8px] font-body font-light uppercase tracking-[0.15em]">Story</span>
      </Link>

      <Link 
        to="/checkout"
        aria-label="Go to Checkout page"
        className="flex flex-col items-center gap-1 text-foreground hover:opacity-70 transition-opacity min-w-[48px] min-h-[48px] justify-center px-3"
      >
        <ShieldCheck size={18} strokeWidth={1.5} />
        <span className="text-[8px] font-body font-light uppercase tracking-[0.15em]">Bag</span>
      </Link>
    </nav>
  );
};

export default BottomNav;
